<ng-container *ngIf="!linkTo; else hasLink">
  <a class="btn btn-link btn-sm">
    <clr-icon [attr.shape]="iconShape"></clr-icon>
    {{ label }}
  </a>
</ng-container>

<ng-template #hasLink>
  <ng-container *ngIf="!disabled; else disabledLink">
    <a class="btn btn-link btn-sm" [routerLink]="linkTo">
      <clr-icon [attr.shape]="iconShape"></clr-icon>
      {{ label }}
    </a>
  </ng-container>
</ng-template>
<ng-template #disabledLink>
  <button class="btn btn-link btn-sm" disabled>
    <clr-icon [attr.shape]="iconShape"></clr-icon>
    {{ label }}
  </button>
</ng-template>
